import { render, staticRenderFns } from "./AmetrasSimpleTextOutputTemplate.vue?vue&type=template&id=8a1c5034&"
import script from "./AmetrasSimpleTextOutputTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasSimpleTextOutputTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasSimpleTextOutputTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports